import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import {
  Table, Row, Cell
} from '../../../components/table';
import { batchRequest } from '../../../../../api/ApiService';

import { getProductRowColor, getProductNameColor } from '../../../../../api/PerformanceFeedback';

class MarketShareStep2 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      products: [],
    };
  }

  componentDidMount() {
    const { activeRound, rounds } = this.props;
    const round = rounds.find(i => i.number === activeRound);
    const roundId = round ? round.id : 0;

    batchRequest([
      `${process.env.REACT_APP_API_URL}team/products/?round_lte=${activeRound}`,
      `${process.env.REACT_APP_API_URL}team/price_forecasts/?round_number=${activeRound}`
    ])
      .then(res => {
        const priceForecasts = res[1].body;
        const products = res[0].body.filter(i => Number(i.round) === roundId).map(product => {
          const priceForecast = priceForecasts.find(priceForecast => priceForecast.product === product.id);
          return (
            {
              name: product.name,
              pixels_rank: product.pixels_rank,
              sensitivity_rank: product.sensitivity_rank,
              power_rank: product.power_rank,
              temp_range_rank: product.temp_range_rank,
              price: priceForecast ? priceForecast.price : 1
            }
          )
        });

        this.setState({
          products,
        });
      })
      .catch(err => { });
  }

  render() {
    const { products } = this.state;
    const { previousShownErrors } = this.props;

    return (
      <BannerLayout
        section="FEEDBACK"
        subSection="MARKET SHARE"
        previousShownErrors={previousShownErrors}
        alertText="Pricing Issue: At least one of your products’ selling prices is outside of what the customer is willing to pay"
        paragraph2={(
          <Fragment>
            Make sure to review the Customer Analysis page to ensure that your marketing mix is aligned with customers’ preferences.
          </Fragment>
        )}
        visual={(
          <Table>
            <Row background="#2a4169">
              <Cell color="#ffffff" />
              <Cell color="#ffffff">Price</Cell>
              <Cell color="#ffffff">Resolution</Cell>
              <Cell color="#ffffff">Sensitivity</Cell>
              <Cell color="#ffffff">Power</Cell>
              <Cell color="#ffffff">Temp Range</Cell>
            </Row>
            {products.map((product, index) => (
              <Row background={getProductRowColor(index)} key={index}>
                <Cell color="rgba(0, 27, 59, 0.94)" background={getProductNameColor(index)}>{product.name}</Cell>
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">
                  {product.price.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    maximumFractionDigits: 2,
                  })}
                </Cell>
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.pixels_rank}</Cell>
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.sensitivity_rank}</Cell>
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.power_rank}</Cell>
                <Cell color="rgba(0, 27, 59, 0.94)" fontWeight="500">{product.temp_range_rank}</Cell>
              </Row>
            ))}
          </Table>
        )}
        visualProps={{
          noBorder: true,
          noBackground: true,
        }}
      />
    );
  }

}

export default MarketShareStep2;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step2.js